// extracted by mini-css-extract-plugin
export default {"dl":"Dl_dl__Zkq7a"};